import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import translationEN from "./src/lang/en/translation.json";
import translationPT from "./src/lang/pt/translation.json";

/* eslint-disable @typescript-eslint/no-explicit-any */
export interface LangList {
    en: any,
    pt: any
}


export function StartLang(props : LangList){
  const en = {...translationEN, ...props.en};
  const pt = {...translationPT, ...props.pt};
  
    const resources = {
        en: {
          translation: en,
        },
        pt: {
          translation: pt,
        }
      };
    
    i18n
      .use(initReactI18next) // passes i18n down to react-i18next
      .init({
        resources,
        lng: "pt", // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
        // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
        // if you're using a language detector, do not define the lng option
        fallbackLng: "pt",
        interpolation: {
          escapeValue: false,
        }
      });
}

export default i18n;

